import App from './App.vue';

export default {
  path: '/CDS_VF_LifelineLPGasDetail',
  name: 'CDS_VF_LifelineLPGasDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ライフライン(LPガス)',
      controller: 'CDS_CTR_LifelineLPGasDetail',
    },
  },
};
